var React = require('react');

function IcInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9DA9B6","fillRule":"evenodd","d":"M15.364 2.636a8.998 8.998 0 0 0-12.728 0 9 9 0 0 0 12.728 12.728 8.977 8.977 0 0 0 0-12.728zM10.2 13.781H7.798v-5.94H10.2v5.94zM9 6.841a1.315 1.315 0 1 1-.002-2.63A1.315 1.315 0 0 1 9 6.84z"}));
}

IcInfo.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = IcInfo;

IcInfo.default = IcInfo;
